import React, { useState } from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { Collapse } from 'react-collapse';
import SingleDayMenu from './SingleDayMenu';
import EditIcon from '../../../images/edit_icon.png';
import ArrowBackIcon from '../../../images/arrow-black.png';
import { setQueryParameter } from '../../../utils/url-params';

const SingleTemplateItem = ({
  title,
  onEdit,
  onDelete,
  menu,
  description,
  avgCalories,
  duration,
  id,
}) => {
  const [isOpened, setIsOpened] = useState(false);

  const toggleIsOpened = () => setIsOpened(!isOpened);

  const onEditClick = (e) => {
    e.stopPropagation();
    onEdit();
    setQueryParameter('id', id);
  };

  const onDeleteClick = (e) => {
    e.stopPropagation();
    onDelete();
  };

  const ImgArrow = styled.img`
    position: absolute;
    left: 15px;
    bottom: 25px;
    width: 30px;
    height: 30px;
    transition: 0.3s;
    transform: ${isOpened ? 'rotate(270deg)' : 'rotate(90deg)'};
  `;
  const link = `/templateGenerator/${id}`;

  return (
    <Item>
      <Name onClick={toggleIsOpened}>
        <ImgArrow src={ArrowBackIcon} alt="arrow" isOpened={isOpened} />
        <TitleBlock>
          <Title>{title}</Title>
          <Description>{description}</Description>
          <Description>Среднее количество калорий в день: {avgCalories}</Description>
          <Description>Продолжительность курса: {duration} дней</Description>
        </TitleBlock>
        <EditButton to={link} onClick={onEditClick}>
          <Img src={EditIcon} alt="edit" />
        </EditButton>
        <DeleteButton onClick={onDeleteClick}>x</DeleteButton>
      </Name>
      <Collapse isOpened={isOpened}>
        {menu.map((dayMenu, i) => {
          return <SingleDayMenu key={dayMenu.menuid} dayNumber={i + 1} menu={dayMenu} />;
        })}
      </Collapse>
    </Item>
  );
};

export default SingleTemplateItem;

const Item = styled.div`
  width: 80%;
  margin: 15px auto;
  box-sizing: border-box;
  border: 2px solid #c1c1c1;
  border-radius: 5px;
  box-shadow: 3px 3px 2px #afafaf;
`;

const Title = styled.div`
  margin: 0;
  word-break: break-all;
`;

const Description = styled.div`
  font-size: 14px;
  margin-top: 7px;
  word-break: break-all;
`;

const TitleBlock = styled.div`
  flex-direction: column;
`;

const Name = styled.div`
  position: relative;
  cursor: pointer;
  width: 100%;
  min-height: 80px;
  height: auto;
  padding: 0 190px 0 20%;
  text-align: center;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: center;
  font-size: 28px;
  background: #fff;
  box-sizing: border-box;
  border-bottom: 1px solid #c1c1c1;
  @media (max-width: 992px) {
    padding: 0 160px 0 55px;
  }
  @media (max-width: 768px) {
    height: auto;
    padding: 20px 10px 60px;
  }
  @media (max-width: 500px) {
    font-size: 24px;
  }
  @media (max-width: 350px) {
    font-size: 20px;
  }
`;

const DeleteButton = styled.div`
  position: absolute;
  width: 50px;
  height: 50px;
  right: 10px;
  bottom: 15px;
  box-sizing: border-box;
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  background: #3a3a3a;
  color: #fff;
  border: none;
  border-radius: 5px;
  text-transform: uppercase;
  &:hover {
    background: #4f93c3;
    border: 1px solid #000542;
  }
  @media (max-width: 992px) {
    width: 40px;
    height: 40px;
    bottom: 20px;
  }
  @media (max-width: 768px) {
    bottom: 10px;
  }
`;

const EditButton = styled(Link)`
  background: #fff;
  position: absolute;
  width: 50px;
  height: 50px;
  right: 70px;
  bottom: 15px;
  box-sizing: border-box;
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  color: #fff;
  border: 1px solid #000542;
  border-radius: 5px;
  text-transform: uppercase;
  &:hover {
    background: #4f93c3;
    border: 1px solid #000542;
  }
  @media (max-width: 992px) {
    width: 40px;
    height: 40px;
    bottom: 20px;
    right: 60px;
  }
  @media (max-width: 768px) {
    bottom: 10px;
  }
`;

const Img = styled.img`
  width: 25px;
  height: 25px;
`;



// WEBPACK FOOTER //
// ./src/Components/Templates/TemplatesList/SingleTemplateItem.jsx